<template lang="html">
  <div id="app">
    <app-header :key="$route.fullPath"></app-header>
    <div id="main">
      <div class="container" v-if="isLogined">
        <transition name="router-fade">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
        <transition @after-enter='afterEnter' @before-enter="beforeEnter">
          <!--整张图片-->
          <div class="move_img" v-if="showMoveImg" :style="{left:(cartPositionL-10) + 'px',top:(cartPositionT-10) + 'px'}">
             <div><img :src="moveImgUrl"></div>
          </div>
        </transition>
      </div>
      <transition name="router-fade" v-else>
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
    <div class="clear" style="height:1px">&nbsp;</div>
   <app-footer :key="$route.fullPath"></app-footer>
  </div>
</template>

<script>
import {mapGetters, mapState, mapMutations } from 'vuex'
import AppHeader from '@/components/heads'
import AppFooter from '@/components/footers'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter
  },
  computed: {
    ...mapGetters([
      'isLogined',
      'unreadLength',
      'allMessages',
      'profile'
    ]),
    ...mapState(['cartPositionT', 'cartPositionL', 'showMoveImg', 'elLeft', 'elTop', 'moveImgUrl'])
  },
  methods: {
      ...mapMutations(['ADD_ANIMATION']),
      // 监听图片进入购物车
      listenInCart () {
        this.ADD_ANIMATION({moveShow: false, receiveInCart: true})
      },
      beforeEnter (el) {
        let elStyle = el.style
        let elChild = el.children[0]
        let elChildSty = elChild.style
      
        elStyle.transform = `translate3d(0,${this.elTop - this.cartPositionT}px,0)`
        elChildSty.transform = `translate3d(${-(this.cartPositionL - this.elLeft)}px,0,0) scale(1.2)`
          console.log(elStyle.transform)
        console.log(elChildSty.transform)
      },
      afterEnter (el) {
        let elStyle = el.style
        let elChild = el.children[0]
        let elChildSty = elChild.style
        elStyle.transform = `translate3d(0,0,0)`
        elChildSty.transform = `translate3d(0,0,0) scale(.2)`
        elStyle.transition = 'transform .55s cubic-bezier(.29,.55,.51,1.08)'
        elChildSty.transition = 'transform .55s linear'
        // 动画结束
        elChild.addEventListener('transitionend', () => {
          this.listenInCart()
        })
        elChild.addEventListener('webkitAnimationEnd', () => {
          this.listenInCart()
        })
      }
    },
}
</script>




// WEBPACK FOOTER //
// App.vue?7a80ae77